import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ChatButtonImage from '../../assets/Inicio/message.png';
import CalendlyButtonImage from '../../assets/Inicio/mensaje.webp';
import { motion, AnimatePresence } from 'framer-motion';
import ContactoServicios from '../ContactoServicios/ContactoServicios';
import { sectionVisibility } from '../../config/sectionVisibility';

const showScheduleButton = sectionVisibility.floatingButtons.schedule;

const calendlyUrl =
  'https://calendly.com/grewhub/reuniondeexploracion?hide_event_type_details=1&hide_gdpr_banner=1&text_color=1a3043&primary_color=1a3043';

const FloatingChatButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Función para abrir Calendly directamente
  const handleCalendlyClick = () => {
    // Cargar el script y CSS de Calendly solo una vez
    if (!document.getElementById('calendly-widget-script')) {
      const link = document.createElement('link');
      link.href = 'https://assets.calendly.com/assets/external/widget.css';
      link.rel = 'stylesheet';
      document.head.appendChild(link);

      const script = document.createElement('script');
      script.id = 'calendly-widget-script';
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        if (window.Calendly) {
          window.Calendly.initPopupWidget({ url: calendlyUrl });
        }
      };
    } else if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: calendlyUrl });
    }
  };

  return (
    <>
      {/* Contenedor de los botones flotantes */}
      <div className="fixed bottom-4 right-6 z-50 flex items-center gap-4">
        {/* Botón de chat */}
        <button
          onClick={handleOpenModal}
          aria-label={t('common.chat.openChatAria')}
          className="transition-transform hover:scale-110 bg-white rounded-full shadow-lg flex items-center justify-center w-12 h-12 border border-gray-200"
        >
          <img src={ChatButtonImage} alt="Botón de chat" className="w-12 h-12" />
        </button>
        {/* Botón de Calendly: se controla con sectionVisibility.floatingButtons.schedule */}
        {showScheduleButton && (
          <button
            onClick={handleCalendlyClick}
            aria-label={t('common.chat.scheduleAria')}
            className="transition-transform hover:scale-110 bg-white rounded-full shadow-lg flex items-center justify-center h-12 px-6 border border-gray-200 font-semibold text-[#1a3043] text-base"
            style={{ minWidth: 'auto', borderRadius: '2rem' }}
          >
            {t('common.chat.scheduleCta')}
          </button>
        )}
      </div>

      {/* Modal de contacto */}
      <AnimatePresence>
        {isModalOpen && (
          <>
            {/* Overlay con blur */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[60]"
              onClick={handleCloseModal}
            />

            {/* Modal */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              className="fixed inset-0 flex items-center justify-center z-[70]"
            >
              <div className="bg-white w-full max-w-[600px] max-h-[90vh] overflow-y-auto my-[5vh] relative rounded-lg shadow-xl">
                {/* Botón de cerrar */}
                <button
                  onClick={handleCloseModal}
                  className="absolute top-6 right-6 text-[#152b5a] hover:text-[#1f3f85] z-[80] bg-white rounded-full p-1"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>

                {/* Contenido del formulario */}
                <div className="w-full lg:py-2 lg:px-12 bg-white">
                  <ContactoServicios
                    isModal={true}
                    onClose={handleCloseModal}
                    showBaseSelector={false}
                  />
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default FloatingChatButton;
